import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import videojs from 'video.js';

import TextField from '@mui/material/TextField';

import { getNotes, saveNote } from 'store/lesson-actions';

import Note from './Note/Note';
import Loading from 'components/UI/Loading/Loading';

import classes from './NotesContainer.module.css';

let myPlayer = null;

const NotesContainer = props => {
  const { t } = useTranslation(['notes']);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [newNote, setNewNote] = useState('');
  const dataAcademy = useSelector(state => state.academyInfo);
  const dataLesson = useSelector(state => state.lessonInfo);

  useEffect(() => {
    dispatch(getNotes(props.idLesson, dataAcademy.data.shortName));
    if (props.view === 1) {
      myPlayer = videojs('lessonCourse');
    }
  }, []);

  useEffect(() => {
    if (dataLesson.notes) {
      setIsLoading(false);
    }
  }, [dataLesson.notes]);

  const handleChangeNote = event => {
    myPlayer.pause();
    setNewNote(event.target.value);
  };

  const saveNoteHandler = event => {
    if (event.key === 'Enter') {
      event.preventDefault();
      (async () => {
        const newNoteData = await saveNote(
          props.idLesson,
          Math.round(myPlayer.currentTime()),
          newNote
        );
        if (newNoteData) {
          setNewNote('');
          myPlayer.play();
          dispatch(
            getNotes(props.idLesson, dataAcademy.data.shortName)
          );
        }
      })();
    }
  };

  return (
    <div className={classes.notesContainer}>
      {props.view === 1 ? (
        !isLoading ? (
          <>
            <TextField
              value={newNote}
              onChange={handleChangeNote}
              label={t('take_note')}
              className={classes.newNoteInput}
              multiline
              rows={2}
              onKeyPress={saveNoteHandler}
            />
            {dataLesson.notes.map(note => (
              <Note
                key={note.idEntradaApunte}
                noteData={note}
                idLesson={props.idLesson}
                academyName={dataAcademy.data.shortName}
              />
            ))}
          </>
        ) : (
          <Loading />
        )
      ) : (
        <p className={classes.errorMessage}>{t('not_show_notes')}</p>
      )}
    </div>
  );
};

NotesContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  view: PropTypes.number
};

export default NotesContainer;
